import { IFrameworkConfig } from "../IConfiguration";
import PlotStatusBadge from "../../../Data/Plot/Platypus/PlotBadge";

export const appConfig: IFrameworkConfig = {
    chartsConfig: {
        defaultFontColor: '#666',
        defaultFontSize: 12,
    },
    defaultDateFormat: "DD MMM YYYY",
    defaultDateTimeFormat: "DD MMM YYYY hh:mm a",
    defaultDocumentTitle: "Australian Platypus Monitoring Network",
    defaultRoute: "/home",
    defaultLoginSuccessRoute: '/welcome',
    plotBadgeComponent: PlotStatusBadge,
};
